export default [{
    text: 'На пандусе',
    value: 'onRamp',
}, {
    text: 'Докового типа',
    value: 'dockType',
}, {
    text: 'На нулевой отметке',
    value: 'atZero',
}];
